import { generateCities } from '@/utils/landing-page/statesAndCities';
import { getCompetitionPanelStates } from '@/utils/';
import { MAIN_SERVICES } from '@/utils/constants';
import { getServicesContractors } from '@/services/api/quotation';
import { mapActions } from 'vuex';

import $ from 'jquery';
export default {
    name: 'headerLandingPage',
    async created() {
        this.tagList[1].tagServices = await getServicesContractors();
    },
    async mounted() {
        // animação do pop-up de solicitação de orçamento
        const currentWindowHeight = window.innerHeight;
        const options = {
            top: currentWindowHeight * 1.4,
            bottom: document.body.clientHeight - 400,
            offset: currentWindowHeight - 100
        };
        $('.pushpin').pushpin(options);
        window.addEventListener('scroll', () => {
            const windowHeight = window.innerHeight;
            if (windowHeight != currentWindowHeight) {
                self.currentWindowHeight = windowHeight;
                $('.pushpin').pushpin('remove');
                $('.pushpin').pushpin(options);
            }
        });
        // await this.generateCities(['RJ', 'SP', 'RS', 'MG', 'BA', 'PR', 'DF']);
    },
    methods: {
        generateCities,
        ...mapActions('supplierNetwork', ['clearSuppliers']),
        redirectToStructuredQuote() {
            const query = {
                servico: this.tag && this.tag.name,
                ufs: this.selectedState && this.selectedState.value
            };
            this.$router.push({
                name: 'StructuredQuote',
                query
            });
            this.clearSuppliers();
        }
    },
    data: () => ({
        url: process.env.VUE_APP_STATIC_BASE_URL,
        select2Options: {
            selectedLabel: 'Selecionado',
            selectLabel: 'Selecionar',
            noResultsLabel: 'Nenhum resultado encontrado.'
        },
        statesList: getCompetitionPanelStates(),
        tagList: [
            {
                order: 'Serviços mais buscados',
                tagServices: MAIN_SERVICES
            },
            {
                order: 'Outros serviços',
                tagServices: []
            }
        ],
        tag: null,
        selectedState: null,
        googleAdsRedirectURL: `${process.env.VUE_APP_ADWORDS_URL}/nova/`,
        hero: `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/hero.png`,
        grayBackground: `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/gray-background.png`,
        heroMobile: `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/hero-mobile.png`
    }),
    computed: {
        cssProps() {
            return {
                '--hero': `url(${JSON.stringify(this.hero)})`,
                '--grayBackground': `url(${JSON.stringify(this.grayBackground)})`,
                '--heroMobile': `url(${JSON.stringify(this.heroMobile)})`
            };
        }
    }
};
